module.exports = __webpack_public_path__ + "img/case3_mob.0bff4818.jpg";